// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEvPlug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.388 15.998c-.483.411-1.663.408-2.198.384a3.377 3.377 0 0 1-2.945 1.851c-1.237 0-2.324-.662-3.085-1.865H8.674c-1.056 1.54-2.25 1.865-3.062 1.865-.812 0-2.623-.524-3.212-2.119-1.677-.85-1.34-2.938-.892-3.953a.343.343 0 0 1 .631.268c-.048.096-.984 2.393.686 3.113a.344.344 0 0 1 .192.216c.411 1.333 1.96 1.783 2.605 1.783.954 0 1.835-.57 2.551-1.65a.38.38 0 0 1 .398-.216h5.709a.344.344 0 0 1 .387.216c.63 1.063 1.53 1.65 2.558 1.65 1.395 0 2.115-1.029 2.424-1.643a.343.343 0 0 1 .404-.216c.62.041 1.612.004 1.876-.216.089-.082.288-.63.236-1.505-.027-.46-.175-1.594-.932-2.122-1.348-.936-8.12-4.982-10.355-5.225-1.779-.179-5.108-.508-6.922.97-1.004.816-1.416 1.77-1.094 2.53.357.844 1.701 1.632 4.396 1.53.018.233.066.464.144.685-2.695.117-4.598-.569-5.17-1.94-.446-1.06.037-2.301 1.292-3.33 2.03-1.659 5.537-1.31 7.423-1.12 2.424.232 9.213 4.312 10.677 5.334 1.032.724 1.203 2.15 1.23 2.726.031.706-.078 1.649-.466 1.999z"
    />
    <path
      fill="currentColor"
      d="M7.391 12.336a2.691 2.691 0 0 1-.144-.686 2.06 2.06 0 0 1 0-.291 2.856 2.856 0 0 1 2.908-2.808l1.2.02a.844.844 0 0 1 .823.858v.754h-.282a.343.343 0 1 0 0 .686h.264l-.017 1.135h-.28a.343.343 0 1 0 0 .685h.25v.768a.844.844 0 0 1-.84.83h-.018l-1.2-.02a2.836 2.836 0 0 1-2.005-.871 2.84 2.84 0 0 1-.659-1.06zm.693-.13a2.171 2.171 0 0 0 1.982 1.375l1.203.02a.151.151 0 0 0 .158-.154l.072-4.029a.157.157 0 0 0-.154-.16l-1.204-.021h-.038a2.17 2.17 0 0 0-2.02 2.97z"
    />
    <path
      fill="currentColor"
      d="M11.58 10.4a.343.343 0 0 1 .32-.21h.281l1.097-.017a.343.343 0 1 1 0 .685l-1.12.018h-.261a.343.343 0 0 1-.317-.475zM11.546 12.21a.34.34 0 0 1 .323-.21h1.379a.343.343 0 0 1 0 .686H11.861a.343.343 0 0 1-.316-.476z"
    />
  </svg>
);
export default SvgEvPlug;
